import React from "react";

const TicketStatuses = ({ exclude }) => {
  const statuses = [
    { value: "OPEN", label: "Unopened" },
    { value: "IN_PROGRESS", label: "In Progress" },
    { value: "ADMIN_ACTION_REQUIRED", label: "Support Action Required" },
    { value: "DOCTOR_ACTION_REQUIRED", label: "Doctor Action Required" },
    { value: "ON_HOLD", label: "On Hold" },
    { value: "RESOLVED", label: "Resolved" },
  ];

  return (
    <React.Fragment>
      {statuses
        .filter(status => !exclude.includes(status.value))
        .map(status => (
          <option key={status.value} value={status.value}>
            {status.label}
          </option>
        ))}
    </React.Fragment>
  );
};

TicketStatuses.defaultProps = {
  exclude: []
};

export default TicketStatuses;
